// Constantes partagées pour le module Événements.

export const DEMAND_SOURCES = [
  { v: "mail_entrant",     label: "Demande entrante par mail" },
  { v: "tel_entrant",      label: "Demande entrante par appel téléphonique" },
  { v: "rdv_prospection",  label: "Rendez-vous de prospection" },
  { v: "mail_prospection", label: "Prospection par mail" },
  { v: "tel_prospection",  label: "Prospection téléphonique" },
  { v: "recurrent",        label: "Événement récurrent organisé par AAE" },
];

// Stepper d'avancement — de la commercialisation à la clôture.
// Groupes renommés selon le workflow AAE : Commercialisation / Production / Post-production.
// L'étape "Événement clôturé" clôt la phase Post-production.
export const CHECKPOINTS = [
  { key: "devis_a_faire",          label: "Devis à faire",                    group: "Commercialisation" },
  { key: "devis_a_valider",        label: "Devis à valider",                  group: "Commercialisation" },
  { key: "devis_a_envoyer",        label: "Devis à envoyer",                  group: "Commercialisation" },
  { key: "devis_envoye",           label: "Devis envoyé",                     group: "Commercialisation", withDate: true },
  { key: "devis_valide",           label: "Devis validé",                     group: "Commercialisation", withDate: true },
  { key: "fdr_a_faire",            label: "Feuille de route à faire",         group: "Production" },
  { key: "fdr_a_valider",          label: "Feuille de route à valider",       group: "Production" },
  { key: "fdr_a_envoyer",          label: "Feuille de route à envoyer",       group: "Production" },
  { key: "fdr_envoyee",            label: "Feuille de route envoyée",         group: "Production", withDate: true },
  { key: "facture_a_faire",        label: "Facture à faire",                  group: "Post-production" },
  { key: "facture_a_valider",      label: "Facture à valider",                group: "Post-production" },
  { key: "facture_a_envoyer",      label: "Facture à envoyer",                group: "Post-production" },
  { key: "facture_envoyee",        label: "Facture envoyée",                  group: "Post-production", withDate: true },
  { key: "facture_payee",          label: "Facture payée",                    group: "Post-production", withDate: true },
  { key: "cloture",                label: "Événement clôturé",                group: "Post-production", withDate: true },
];

// Palette par phase : dégradés lime du plus clair (étape 1) au plus foncé (étape finale).
// Toutes les phases utilisent une gamme lime pour rester cohérentes avec la charte du site.
export const PHASE_PALETTE = {
  "Commercialisation": ["#F7FEE7", "#D9F99D", "#A3E635", "#65A30D", "#365314"],
  "Production":        ["#ECFCCB", "#BEF264", "#84CC16", "#4D7C0F"],
  "Post-production":   ["#F7FEE7", "#D9F99D", "#BEF264", "#84CC16", "#4D7C0F", "#1A2E05"],
};

// Couleur de texte associée (foncé sur fonds clairs, blanc sur fonds foncés).
export const PHASE_TEXT_COLOR = {
  "Commercialisation": ["#1A2E05", "#1A2E05", "#1A2E05", "#FFFFFF", "#FFFFFF"],
  "Production":        ["#1A2E05", "#1A2E05", "#FFFFFF", "#FFFFFF"],
  "Post-production":   ["#1A2E05", "#1A2E05", "#1A2E05", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
};

export const EMPTY_EVENT = {
  name: "",
  client: "",
  contact_name: "",
  contact_email: "",
  contact_phone: "",
  start_date: "",
  end_date: "",
  horaire: "",
  horaire_end: "",
  location: "",
  space: "",
  address: "",
  budget: 0,
  budget_type: "HT",
  budget_comment: "",
  phase: "commercialisation",
  description: "",
  referent_id: "",
  tags: [],
  infos_supp: "",
  demande: {
    received_by_id: "",
    source: "",
    decision_date: "",
    decision_comment: "",
    quote_request_date: "",
    quote_request_comment: "",
  },
  brief: {
    contact_full_name: "",
    contact_first_name: "",
    contact_last_name: "",
    entreprise: "",
    email: "",
    phone: "",
    position: "",
    brief_other: "",
  },
  targeting: {
    for_who: "",
    age: "",
    gender: "",
    purpose: "",
    before_after: "",
    previous_events: "",
    other: "",
  },
  ideas: {
    wants: "",
    dont_wants: "",
    other: "",
  },
  margin_manual: null,
  checkpoints: {},
};
